import * as React from "react";
const IconVector = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M55.3 29.2c3.8 0 6.9-3.1 6.9-6.9s-3.1-6.9-6.9-6.9c-3.1 0-5.8 2.1-6.6 4.9H38.6c-.9-2.8-3.5-4.9-6.6-4.9s-5.8 2.1-6.6 4.9H15.3c-.9-2.8-3.5-4.9-6.6-4.9-3.8 0-6.9 3.1-6.9 6.9s3.1 6.9 6.9 6.9c2.9 0 5.4-1.8 6.4-4.4h3.6c-3.5 3-6.1 7.1-7 11.7h-1.3c-2 0-3.6 1.6-3.6 3.6V45c0 2 1.6 3.6 3.6 3.6h7.5c2 0 3.6-1.6 3.6-3.6v-4.9c0-2-1.6-3.6-3.6-3.6h-1.5c1.2-4.9 4.8-9 9.6-10.9 1.2 2.1 3.4 3.6 6 3.6 2.5 0 4.7-1.4 5.9-3.4 4.6 1.9 7.9 5.9 9.1 10.7h-1c-2 0-3.6 1.6-3.6 3.6V45c0 2 1.6 3.6 3.6 3.6h7.5c2 0 3.6-1.6 3.6-3.6v-4.9c0-2-1.6-3.6-3.6-3.6h-1.9c-.9-4.6-3.4-8.8-6.9-11.7h4.2c1 2.6 3.5 4.4 6.4 4.4m0-9.3c1.3 0 2.4 1.1 2.4 2.4s-1.1 2.4-2.4 2.4-2.4-1.1-2.4-2.4 1.1-2.4 2.4-2.4M8.7 24.7c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1.1 2.4-2.4 2.4M17 44.1h-5.7V41H17zm35.7 0H47V41h5.7zM32 24.7c-1.3 0-2.4-1.1-2.4-2.4s1.1-2.4 2.4-2.4 2.4 1.1 2.4 2.4-1.1 2.4-2.4 2.4" />
  </svg>
);
export default IconVector;
